import '../../../common/dashboard/filters/single_filters/multiple_values_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.SingleFilters'

class CustomerVisualMode.Filters.SingleFilters.FixedStringFilterView extends
Common.Sessions.Filters.SingleFilters.MultipleValuesFilterView
  _selector: (values, selectedOptions) ->
    new App.SelectView
      options: values.map((value) ->
        id: value.name
        name: value.name
      )
      selectedOptions: selectedOptions
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: @placeholder
      editable: @editable
      multiple: true
      width: '100%'
      clearableInput: true
